import { Flex, Presence, Tabs } from '@chakra-ui/react';
import { useState } from 'react';

import { ActionTable } from '@/components';
import { PurchaseOrderListMode } from '@/utils/purchaseOrderLifecycle';
import EditPurchaseOrderLines from './EditPurchaseOrderLines';
import PurchaseOrdersTable, {
  PurchaseOrdersTableType,
} from './PurchaseOrdersTable';
import Invoices from './Invoices';

import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
dayjs.extend(isSameOrAfter);

const PurchaseOrders = () => {
  const [openEditPurchaseOrderLinesModal, setOpenEditPurchaseOrderLinesModal] =
    useState<PurchaseOrdersTableType | null>(null);

  const [openInvoicesModal, setOpenInvoicesModal] =
    useState<PurchaseOrdersTableType | null>(null);
  const [listMode, setListMode] = useState<PurchaseOrderListMode>('active');

  return (
    <Flex flexDirection="column">
      <Presence
        present={
          openEditPurchaseOrderLinesModal === null && openInvoicesModal === null
        }
        animationName={{ _open: 'fade-in', _closed: 'fade-out' }}
        animationDuration="faster"
      >
        <Flex flexDirection="column" gapY={3}>
          <Tabs.Root
            value={listMode}
            onValueChange={({ value }) =>
              setListMode(value as PurchaseOrderListMode)
            }
            variant="line"
          >
            <Tabs.List>
              <Tabs.Trigger value="active">Purchase Orders</Tabs.Trigger>
              <Tabs.Trigger value="cancelled">Cancelled POs</Tabs.Trigger>
            </Tabs.List>
          </Tabs.Root>
          <PurchaseOrdersTable
            listMode={listMode}
            handleOpenEditPurchaseOrderModal={
              setOpenEditPurchaseOrderLinesModal
            }
            handleOpenInvoicesModal={setOpenInvoicesModal}
          />
        </Flex>
      </Presence>

      <Presence
        present={
          openEditPurchaseOrderLinesModal !== null && openInvoicesModal === null
        }
        animationName={{ _open: 'fade-in', _closed: 'fade-out' }}
        animationDuration="faster"
      >
        <ActionTable.Provider>
          <EditPurchaseOrderLines
            purchaseOrderId={openEditPurchaseOrderLinesModal?.id ?? null}
            onClose={() => setOpenEditPurchaseOrderLinesModal(null)}
          />
        </ActionTable.Provider>
      </Presence>

      <Presence
        present={
          openInvoicesModal !== null && openEditPurchaseOrderLinesModal === null
        }
        animationName={{ _open: 'fade-in', _closed: 'fade-out' }}
        animationDuration="faster"
      >
        <Invoices
          onClose={() => setOpenInvoicesModal(null)}
          purchaseOrder={openInvoicesModal ?? undefined}
        />
      </Presence>
    </Flex>
  );
};
export default PurchaseOrders;
